import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loading } from "@/components/app/primitives";

export default function AuthCallback() {
  const { completeGoogleLogin } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get("code");
    const err = params.get("error");
    const errDesc = params.get("error_description");
    if (err) {
      setError(`Google returned: ${err}${errDesc ? `. ${errDesc.replace(/\+/g, " ")}` : ""}`);
      return;
    }
    if (!code) {
      setError("No authorization code was returned by Google.");
      return;
    }
    completeGoogleLogin(code)
      .then(() => navigate("/", { replace: true }))
      .catch((e) => {
        const detail = e?.response?.data?.detail || "Sign-in could not be completed.";
        setError(typeof detail === "string" ? detail : "Sign-in could not be completed.");
      });
  }, [completeGoogleLogin, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6">
      {error ? (
        <div className="max-w-sm text-center">
          <h1 className="font-display text-xl text-foreground">Sign-in interrupted</h1>
          <p className="mt-2 text-sm text-muted-foreground">{error}</p>
          <button
            onClick={() => navigate("/login", { replace: true })}
            className="mt-5 rounded-md border border-border bg-card px-4 py-2 text-sm text-foreground hover:bg-white/5"
          >
            Back to sign-in
          </button>
        </div>
      ) : (
        <Loading label="Completing Google sign-in" />
      )}
    </div>
  );
}
